import * as React from 'react';
import { H2 } from '../HTML/Heading';
import { Button, Checkbox, FormControlLabel, Grid } from '@mui/material';
import Panel from '../Panel';
import TextoLegal from '../TerminosCondicionesPoliticas/TextoLegal';
import { AppContext } from '../../providers/AppContext';

export default function AceptarTyCParaContinuar(props){
    const {children}=props;
    const {tycAccepted, setTyCAccepted} = React.useContext(AppContext);
    const {tycCheckbox, setTyCCheckbox} = React.useContext(AppContext);
    const continueCallback = () => {
        if(tycCheckbox === true){
            setTyCAccepted(true);
        }else{
            alert('Debes aceptar los términos y condiciones para continuar.');
        }
    }
    return <>
        {tycAccepted === false && <>
            <Grid item xs={12}>
                <Panel>
                    <H2>Calculadora de ratings</H2>
                    <p>Antes de utilizar la calculadora de ratings, debes aceptar los "Términos y Condiciones de Uso".</p>
                    <TextoLegal />
                    
                    <br/>
                    <div>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={Boolean(tycCheckbox)}
                                    onChange={(event) => setTyCCheckbox(event.target.checked)}
                                />
                            }
                            label='He leido y acepto los "Términos y Condiciones de Uso".'
                            sx={{
                                alignItems: 'center',
                                '& .MuiFormControlLabel-label': {
                                    fontSize: '1em'
                                }
                            }}
                        />
                    </div>
                    <div>
                        <Button variant="contained" onClick={continueCallback}>Continuar</Button>
                    </div>
                    
                </Panel>
            </Grid>
        </>}
        {tycAccepted !== false && <>{children}</>}       
    </>
}